import { render, staticRenderFns } from "./CustomInvoiceForm.vue?vue&type=template&id=57c61d4a&"
import script from "./CustomInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./CustomInvoiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports